import { render, staticRenderFns } from "./tbkpytTjzbhxr.vue?vue&type=template&id=54e84272&scoped=true&"
import script from "./tbkpytTjzbhxr.vue?vue&type=script&lang=js&"
export * from "./tbkpytTjzbhxr.vue?vue&type=script&lang=js&"
import style0 from "./tbkpytTjzbhxr.vue?vue&type=style&index=0&id=54e84272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e84272",
  null
  
)

export default component.exports